import React from 'react'
import { Helmet } from 'react-helmet'
import { observer, inject } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import EnumForm from './parts/enum_form'
import EnumEdit from './parts/enum_edit'
import HelpOverlay from '../utils/helpOverlay'

const EnumsEdit = observer(({ store }) => {
  if (!store.hasRight(linkConst.LINK_ENUMS)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const tablang = store.router && store.router.queryParams && store.router.queryParams._tablang
  const children = store.cv.root.children
  const refs = {}
  const scrollSeparator = '|'
  const scrollPath = (store.router && store.router.queryParams && store.router.queryParams._autoscroll) || ''
  const [enumParent, enumValue] = (!scrollPath ? [] : scrollPath.indexOf(scrollSeparator)
    ? scrollPath.split(scrollSeparator)
    : [scrollPath])

  refs.scrollPath = React.createRef()

  const found = children.find(c => c.value === enumParent)
  if (found) {
    store.openEnumItem = enumValue || enumParent
    store.cv.loadEnums(found)
    if (found && refs.scrollPath) {
      setTimeout(
        () => {
          refs.scrollPath.current && refs.scrollPath.current.scrollIntoView(true)
          window.scrollBy(0, -70)
        }, 500
      )
    }
  }

  const addButt = store.hasRight(linkConst.LINK_ENUMS, 'w') ? (
    <div className='pull-right'>
      <button type='button' className='btn btn-primary' onClick={() => store.cv.addEnumItem()}>
        <em className='glyphicon glyphicon-plus-sign' />&nbsp;{store.__(defaultConst.TITLE_CREATE)}
      </button>
    </div>
  ) : null

  return children.length > 0
    ? (<div className='card'>
      <Helmet title={store.__(linkConst.LINK_ENUMS_TITLE)} />
      <div className='card-block'>
        {addButt}
        <h4 className='card-title' style={{ margin: '1.2em 0' }}>
          {store.__(linkConst.LINK_ENUMS_TITLE)}
          <HelpOverlay helpContent={store.helpFor(linkConst.LINK_ENUMS)} />
        </h4>
        <div className='card-block'>
          <div className='panel-group' id='accordion' role='tablist'>
            {
              children.map((e, idx) => {
                return <EnumEdit
                  enm={e}
                  enumValue={enumValue}
                  key={idx}
                  ref={e.value === enumParent ? refs.scrollPath : undefined}
                  store={store}
                />
              })
            }
          </div>
          <EnumForm store={store} tablang={tablang} />
        </div>
      </div>
    </div>
    )
    : <span>{store.__('Loading')}</span>
})

export default inject('store')(observer(EnumsEdit))
